<template>




   <section class="pa-9">
      <article>
         <!-- video 301 c in series -->
         <h1> 最善の生活</h1>

         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/xGsd-HstPMw" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>

      <article>
         <!-- video 302 c in series -->
         <h1>  あなたの選択  </h1>

         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/QDdAoKeWyWg" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>

      <article>
         <!-- video 303 c in series -->
         <h1>  時限爆弾の上にすわっている </h1>

         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/ZY2jpQ70qD8" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>







      <article>
         <!-- video 304 c in series -->
         <h1>  驚くべき乳房  </h1>

         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/o6BwhNgqmwI" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>

      <article>
         <!-- video 305 c in series -->
         <h1>  健康と幸福   </h1>

         <div class="flex-center">
            <iframe width="640" height="480" src="//www.youtube.com/embed/geUis1pAlhQ" frameborder="0" allowfullscreen></iframe>
         </div>

      </article>

   </section>




</template>

<script>



export default {
name: "landmarkProphecy",
   components: { },
}
</script>

<style scoped>
article{
    margin-bottom: 50px;
}
</style>
